import InvoiceDisplay from "./invoiceDisplay";
export default InvoiceDisplay;
